const authHeaders = (token: string, headers = {}) => ({
  headers: {
    ...headers,
    Authorization: `Bearer ${token}` ,
  },
})
export default authHeaders



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./core/src/api/study_coordinator/authHeaders.ts